import { KeycloakService } from "keycloak-angular";
import { environment } from "src/environments/environment";
import { SKIP_KEYCLOAK_INTERCEPTOR } from "src/modules/mgmt-api-client/api/transferProcess.service";

export function initializeKeycloak(
    keycloak: KeycloakService,
) {
    return () => {
        const resolvedKeycloakUrl = new URL(environment.kcUrl, window.location.origin).toString();

        return keycloak.init({
            config: {
                url: resolvedKeycloakUrl,
                realm: environment.kcRealm,
                clientId: environment.kcClientId,
            },
            initOptions: {
                //redirectUri: environment.redirectUri,
                checkLoginIframe: false
            },
            shouldAddToken: (request: any) => {
                // No añadir token de Keycloak si el contexto tiene SKIP_KEYCLOAK_INTERCEPTOR
                const skipKeycloak = request.context?.get(SKIP_KEYCLOAK_INTERCEPTOR);
                return !skipKeycloak;
            }
        });
    }
}